import axios from 'axios';
import useSWR from 'swr';

export const useTogalIntegrations = (companyUid) => {
  const url = `/admin/togal-integration/${companyUid}`;
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};
